// import React, { useState } from "react";


// function ClientDataResume(props) {

//     return (
//         <div className="bg-slate-50 py-5">
//             <div className="font-bold text-2xl px-4 text-gray-600 mb-3 text-center">
//                 <p>Datos Personales</p>
//             </div>
//             <table className="mx-auto">
//                 <tbody>
//                     <tr>
//                         <th className="text-gray-600 text-right">NOMBRE: </th>
//                         <td className="text-gray-500 text-left">&nbsp; {props.clientData.name} {props.clientData.lastName}</td>
//                     </tr>
//                     <tr>
//                         <th className="text-gray-600 text-right">CELULAR: </th>
//                         <td className="text-gray-500 text-left">&nbsp; +56{props.clientData.phoneNumber}</td>
//                     </tr>
//                     <tr>
//                         <th className="text-gray-600 text-right">EMAIL: </th>
//                         <td className="text-gray-500 text-left">&nbsp; {props.clientData.email}</td>
//                     </tr>
//                 </tbody>
//             </table>
//         </div>
//     );
// }

// export default ClientDataResume;


import React from "react";

function ClientDataResume(props) {
    return (
        <div className="mx-3 rounded-2xl overflow-hidden bg-white border border-gray-100 shadow-sm">

            {/* Header */}
            <div className="px-4 py-3 flex items-center gap-2 bg-[#f7f4ef] border-b border-gray-100">
                <svg className="w-4 h-4 text-[#a02338] flex-shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
                </svg>
                <p className="text-sm font-semibold text-[#2a1419]">Datos personales</p>
            </div>

            {/* Contenido */}
            <div className="px-4 py-3 flex flex-col gap-2">
                <div className="flex items-center gap-3">
                    <span className="text-[11px] text-gray-400 w-16 flex-shrink-0">Nombre</span>
                    <span className="text-[13px] font-medium text-[#2a1419]">
                        {props.clientData.name} {props.clientData.lastName}
                    </span>
                </div>
                <div className="flex items-center gap-3 border-t border-gray-50 pt-2">
                    <span className="text-[11px] text-gray-400 w-16 flex-shrink-0">Celular</span>
                    <span className="text-[13px] font-medium text-[#2a1419]">
                        +56 {props.clientData.phoneNumber}
                    </span>
                </div>
                <div className="flex items-center gap-3 border-t border-gray-50 pt-2">
                    <span className="text-[11px] text-gray-400 w-16 flex-shrink-0">Email</span>
                    <span className="text-[13px] font-medium text-[#2a1419] truncate">
                        {props.clientData.email}
                    </span>
                </div>
            </div>
        </div>
    );
}

export default ClientDataResume;